import { Box, Typography } from "@mui/material";
import classes from "./index.module.scss";
import { useTheme } from "@emotion/react";

export default function ModuleSummary({ lecturesCount, lecturesDuration, title }) {
  const theme = useTheme();
  return (
    <Box className={classes.summary}>
      <Typography
        color={theme.palette.dark}
        className={classes.summary__title}
        component="h3"
      >
        {title}
      </Typography>
      <Typography
        color={theme.palette["dark-60"]}
        className={classes.summary__subtitle}
      >
        {lecturesCount} {lecturesCount !== 1 ? "lectures" : "lecture"} ({lecturesDuration})
      </Typography>
    </Box>
  );
}
